export const baseModifier: string[] = ['command', 'option']

export const keyBinds: Record<string, string[]> = {
    // Sequence shortcuts: use 'then' between keys (e.g., type "sql" to open SQL editor)
    sqlEditor: ['s', 'then', 'q', 'then', 'l'],
    toggleLeftNav: ['command', 'b'],
    toggleLeftNavFallback: ['['],
    toggleRightNav: [']'],
    helpMenu: ['?'],
    newAccountMenu: ['g', 'then', 'a'],
    projectSwitcher: ['g', 'then', 'p'],
    orgSwitcher: ['g', 'then', 'o'],
    quickStart: ['g', 'then', 's'],
    recentItems: [...baseModifier, 'y'],
    toggleShortcutMenu: [...baseModifier, 'k'],
    toggleShortcutMenuFallback: ['command', 'shift', 'k'],
    search: ['command', 'k'],
    new: [...baseModifier, 'n'],
    edit: ['e'],
    escape: ['escape'],
    save: [...baseModifier, 's'],
    dashboardAddTextTile: [...baseModifier, 'a'],
    filter: [...baseModifier, 'f'],
    refresh: [...baseModifier, 'r'],
    run: [...baseModifier, 'enter'],
    settings: [...baseModifier, 'g'],
    dateFilter: [...baseModifier, 'd'],
    tab1: [...baseModifier, '1'],
    tab2: [...baseModifier, '2'],
    tab3: [...baseModifier, '3'],
    tab4: [...baseModifier, '4'],
    tab5: [...baseModifier, '5'],
    tab6: [...baseModifier, '6'],
    tab7: [...baseModifier, '7'],
    tab8: [...baseModifier, '8'],
    tab9: [...baseModifier, '9'],
    zenMode: [...baseModifier, 'z'],
    newChat: ['g', 'then', 'n'],
    maxHandsFree: ['h', 'then', 'f'],
    allChats: ['g', 'then', '1'],
    allProducts: ['g', 'then', '2'],
    theme: ['g', 'then', 't'],
    jumpToTimestamp: ['j', 'then', 't'],
}
